import {applySpec, defaultTo, flow, get} from '@yandex-delivery/utils'
import type {PaymentInfo, PaymentInfoDetails} from 'src/shared/types'

export const fromPaymentInfo: (
  paymentInfoDetails?: PaymentInfoDetails,
) => PaymentInfo = applySpec<PaymentInfo>({
  type: flow(get('type'), defaultTo('cargocorp')),
  method_id: get('methodId'),
  kind: flow(get('kind'), defaultTo('card')),
  has_disable_reason: get('hasDisableReason'),
})
